import dayjs from "dayjs";

export const isOnline = (lastSeen: string) => dayjs().diff(dayjs(lastSeen), "minute") <= 10;
